import { useContext } from "react";
import { motion } from "motion/react";
import { AuthContext } from "../../context/AuthContext";
import { format } from "date-fns";
import { Link } from "react-router-dom";

const Blog = () => {
  const authContext = useContext(AuthContext);
  if (!authContext) {
    return null;
  }
  return (
    <div className="max-w-screen-2xl mx-auto px-5 sm:px-20 py-10 sm:py-28">
      <div className="">
        <div className="flex flex-col justify-center sm:items-center">
          <div className="relative mb-9">
            <motion.h3
              initial={{ y: -100, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
              className="poppins-regular text-primary z-20 relative"
            >
               BLOG
            </motion.h3>
            <div className="size-16 bg-[#E7E9FF] rounded-full absolute -top-5 -left-5"></div>
          </div>
          <motion.h2
            initial={{ y: -100, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.5 }}
            viewport={{ once: true }}
            className="text-4xl sm:text-5xl montserrat-regular text-secondary sm:text-center mb-6"
          >
            Insights from a{" "}
            <span className="montserrat-semibold">Financial Leader</span>
          </motion.h2>
          <motion.p
            initial={{ y: -100, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.5 }}
            viewport={{ once: true }}
            className="montserrat-regular text-secondary sm:text-center mb-6"
          >
            With over 30 years of financial expertise in healthcare, I offer a
            range of specialized services to drive growth, stability, and
            innovation within the medical sector.
          </motion.p>
        </div>
        <div className="grid lg:grid-cols-2 xl:grid-cols-3 gap-4 mb-6">
          {authContext.blogs.slice(0, 3).map((item, index) => (
            <Link
              to={`/blog/${item.slug}`}
              state={{ blog: item }}
              onClick={() => window.scrollTo(0, 0)}
              key={index}
            >
              <div className="relative rounded  overflow-hidden group h-[400px]">
                <img
                  src={`https://admin.techqilla.com${item.image.url}`}
                  alt=""
                  className="w-full h-full rounded group-hover:scale-125 transition-all duration-1000 object-cover"
                />
                <div className="w-full h-[50%] flex flex-col justify-end p-8 absolute bottom-0 text-white bg-gradient-to-t from-secondary to-transparent">
                  <p className="montserrat-semibold text-sm mb-2">
                    {format(new Date(item.createdAt), "dd MMM yyyy")}
                  </p>
                  <h3 className="montserrat-semibold text-xl">
                    {item.title.split(" ").slice(0, 8).join(" ")}...
                  </h3>
                </div>
              </div>
            </Link>
          ))}
        </div>
        <div className="flex justify-center items-center">
          <Link to="/blogs" onClick={() => window.scrollTo(0, 0)}>
            <button className="py-3 px-8 montserrat-medium bg-secondary rounded-full text-white hover:bg-primary transition-all duration-300">
              View All
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Blog;
